/**
 * SVG texture patterns for visual depth.
 */

/** Topographic contour lines — uses the full topo SVG as a background image */
export function TopoContours({ className = '' }: { className?: string }) {
  return (
    <div
      className={`absolute inset-0 ${className}`}
      style={{
        backgroundImage: 'url(/topo-pattern.svg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        opacity: 0.08,
        zIndex: 0,
      }}
      aria-hidden="true"
    />
  )
}
